import React from 'react';
import SearchableSelect from './SearchableSelect';
import { Controller } from 'react-hook-form';

const FormField = ({ 
  label, 
  name, 
  type = 'text', 
  register, 
  control,
  error, 
  required = false,
  options = [],
  placeholder,
  className = '',
  ...props 
}) => {
  const renderInput = () => {
    switch (type) {
      case 'select':
        return (
          <Controller
            name={name}
            control={control}
            rules={{ required: required && `${label} is required` }}
            render={({ field }) => (
              <SearchableSelect
                options={options}
                value={field.value || ''}
                onChange={field.onChange}
                placeholder={placeholder || `Select ${label}`}
                error={error}
                className={className}
                name={name}
                {...props}
              />
            )}
          />
        );
      
      case 'textarea':
        return (
          <textarea
            {...register(name, { required: required && `${label} is required` })}
            className={`form-input resize-none ${error ? 'border-red-500' : ''} ${className}`}
            rows={4}
            placeholder={placeholder}
            {...props}
          />
        );
      
      case 'checkbox':
        return (
          <div className="flex items-center">
            <input
              type="checkbox"
              {...register(name)}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              {...props}
            />
            <label className="ml-2 text-sm text-gray-700">{placeholder}</label>
          </div>
        );
      
      default:
        const validationRules = { required: required && `${label} is required` };
        
        if (type === 'email') {
          validationRules.pattern = {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Please enter a valid email address'
          };
        }
        
        return (
          <input
            type={type}
            {...register(name, validationRules)}
            className={`form-input ${error ? 'border-red-500' : ''} ${className}`}
            placeholder={placeholder}
            {...props}
          />
        );
    }
  };

  return (
    <div className="space-y-1">
      {type !== 'checkbox' && (
        <label className="form-label text-xs sm:text-sm">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {renderInput()}
      {error && <p className="form-error text-xs">{error.message}</p>}
    </div>
  );
};

export default FormField;